import React from "react";
import { HiOutlineVideoCamera } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneMovie } from "../../../lib/sysNavigation/SysNavigation";

type MovieRow = {
  movie_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<MovieRow>
    type={_TYPES_.MOVIE}
    title="Movies"
    subtitle="Movies promoted on the public site."
    icon={<HiOutlineVideoCamera className="h-5 w-5" />}
    addRoute="/data/movie/add"
    editRoute="/data/movie/edit"
    pushOne={pushOneMovie}
    dataKey="movies"
    countKey="moviesCount"
    idField="movie_id"
  />
);

export default Overview;
